import _defineProperty from "/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/im-question-mark/im-question-mark/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["__scopeDropdownMenu", "disabled"],
    _excluded2 = ["__scopeDropdownMenu"],
    _excluded3 = ["__scopeDropdownMenu", "portalled"],
    _excluded4 = ["__scopeDropdownMenu"],
    _excluded5 = ["__scopeDropdownMenu"],
    _excluded6 = ["__scopeDropdownMenu"],
    _excluded7 = ["__scopeDropdownMenu"],
    _excluded8 = ["__scopeDropdownMenu"],
    _excluded9 = ["__scopeDropdownMenu"],
    _excluded10 = ["__scopeDropdownMenu"],
    _excluded11 = ["__scopeDropdownMenu"],
    _excluded12 = ["__scopeDropdownMenu"],
    _excluded13 = ["__scopeDropdownMenu"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useId as e } from "@radix-ui/react-id";
import * as o from "@radix-ui/react-menu";
import { createMenuScope as n } from "@radix-ui/react-menu";
import { Primitive as r } from "@radix-ui/react-primitive";
import { useControllableState as t } from "@radix-ui/react-use-controllable-state";
import { createContextScope as p } from "@radix-ui/react-context";
import { composeRefs as d } from "@radix-ui/react-compose-refs";
import { composeEventHandlers as a } from "@radix-ui/primitive";
import * as c from "react";
import u from "@babel/runtime/helpers/esm/extends";

var _p = p("DropdownMenu", [n]),
    _p2 = _slicedToArray(_p, 2),
    s = _p2[0],
    i = _p2[1];

export { i as createDropdownMenuScope };

var l = n(),
    _s = s("DropdownMenu"),
    _s2 = _slicedToArray(_s, 2),
    m = _s2[0],
    w = _s2[1];

export var DropdownMenu = function DropdownMenu(e) {
  var n = e.__scopeDropdownMenu,
      r = e.children,
      p = e.open,
      d = e.defaultOpen,
      a = e.onOpenChange,
      s = M("DropdownMenu", n),
      i = l(n),
      _t = t({
    prop: p,
    defaultProp: d,
    onChange: a
  }),
      _t2 = _slicedToArray(_t, 2),
      _t2$ = _t2[0],
      w = _t2$ === void 0 ? !1 : _t2$,
      D = _t2[1],
      g = c.useCallback(function () {
    return D(function (e) {
      return !e;
    });
  }, [D]);

  return s.isInsideContent ? /*#__PURE__*/c.createElement(m, {
    scope: n,
    isRootMenu: !1,
    open: w,
    onOpenChange: D,
    onOpenToggle: g
  }, /*#__PURE__*/c.createElement(o.Sub, u({}, i, {
    open: w,
    onOpenChange: D
  }), r)) : /*#__PURE__*/c.createElement(f, u({}, e, {
    open: w,
    onOpenChange: D,
    onOpenToggle: g
  }), r);
};
/*#__PURE__*/

var f = function f(n) {
  var r = n.__scopeDropdownMenu,
      t = n.children,
      p = n.dir,
      d = n.open,
      a = n.onOpenChange,
      s = n.onOpenToggle,
      _n$modal = n.modal,
      i = _n$modal === void 0 ? !0 : _n$modal,
      w = l(r),
      f = c.useRef(null);
  /*#__PURE__*/

  return c.createElement(m, {
    scope: r,
    isRootMenu: !0,
    triggerId: e(),
    triggerRef: f,
    contentId: e(),
    open: d,
    onOpenChange: a,
    onOpenToggle: s,
    modal: i
  }, /*#__PURE__*/c.createElement(o.Root, u({}, w, {
    open: d,
    onOpenChange: a,
    dir: p,
    modal: i
  }), t));
};

export var DropdownMenuTrigger = /*#__PURE__*/c.forwardRef(function (e, n) {
  var t = e.__scopeDropdownMenu,
      _e$disabled = e.disabled,
      p = _e$disabled === void 0 ? !1 : _e$disabled,
      s = _objectWithoutProperties(e, _excluded),
      i = w("DropdownMenuTrigger", t),
      m = l(t);

  return i.isRootMenu ? /*#__PURE__*/c.createElement(o.Anchor, u({
    asChild: !0
  }, m), /*#__PURE__*/c.createElement(r.button, u({
    type: "button",
    id: i.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": !!i.open || void 0,
    "aria-controls": i.open ? i.contentId : void 0,
    "data-state": i.open ? "open" : "closed",
    "data-disabled": p ? "" : void 0,
    disabled: p
  }, s, {
    ref: d(n, i.triggerRef),
    onPointerDown: a(e.onPointerDown, function (e) {
      p || 0 !== e.button || !1 !== e.ctrlKey || (i.open || e.preventDefault(), i.onOpenToggle());
    }),
    onKeyDown: a(e.onKeyDown, function (e) {
      p || (["Enter", " "].includes(e.key) && i.onOpenToggle(), "ArrowDown" === e.key && i.onOpenChange(!0), [" ", "ArrowDown"].includes(e.key) && e.preventDefault());
    })
  }))) : null;
});
/*#__PURE__*/

var _s3 = s("DropdownMenuContent", {
  isInsideContent: !1
}),
    _s4 = _slicedToArray(_s3, 2),
    D = _s4[0],
    M = _s4[1];

export var DropdownMenuContent = /*#__PURE__*/c.forwardRef(function (e, n) {
  var r = e.__scopeDropdownMenu,
      t = _objectWithoutProperties(e, _excluded2),
      p = w("DropdownMenuContent", r),
      d = l(r),
      a = _objectSpread(_objectSpread({}, t), {}, {
    style: _objectSpread(_objectSpread({}, e.style), {}, {
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)"
    })
  });
  /*#__PURE__*/


  return c.createElement(D, {
    scope: r,
    isInsideContent: !0
  }, p.isRootMenu ? /*#__PURE__*/c.createElement(g, u({
    __scopeDropdownMenu: r
  }, a, {
    ref: n
  })) : /*#__PURE__*/c.createElement(o.Content, u({}, d, a, {
    ref: n
  })));
});
/*#__PURE__*/

var g = /*#__PURE__*/c.forwardRef(function (e, n) {
  var r = e.__scopeDropdownMenu,
      _e$portalled = e.portalled,
      t = _e$portalled === void 0 ? !0 : _e$portalled,
      p = _objectWithoutProperties(e, _excluded3),
      d = w("DropdownMenuContent", r),
      s = l(r),
      i = c.useRef(!1);

  return d.isRootMenu ? /*#__PURE__*/c.createElement(o.Content, u({
    id: d.contentId,
    "aria-labelledby": d.triggerId
  }, s, p, {
    ref: n,
    portalled: t,
    onCloseAutoFocus: a(e.onCloseAutoFocus, function (e) {
      var o;
      i.current || null === (o = d.triggerRef.current) || void 0 === o || o.focus(), i.current = !1, e.preventDefault();
    }),
    onInteractOutside: a(e.onInteractOutside, function (e) {
      var o = e.detail.originalEvent,
          n = 0 === o.button && !0 === o.ctrlKey,
          r = 2 === o.button || n;
      d.modal && !r || (i.current = !0);
    })
  })) : null;
});
export var DropdownMenuGroup = /*#__PURE__*/c.forwardRef(function (e, n) {
  var r = e.__scopeDropdownMenu,
      t = _objectWithoutProperties(e, _excluded4),
      p = l(r);
  /*#__PURE__*/


  return c.createElement(o.Group, u({}, p, t, {
    ref: n
  }));
});
/*#__PURE__*/

export var DropdownMenuLabel = /*#__PURE__*/c.forwardRef(function (e, n) {
  var r = e.__scopeDropdownMenu,
      t = _objectWithoutProperties(e, _excluded5),
      p = l(r);
  /*#__PURE__*/


  return c.createElement(o.Label, u({}, p, t, {
    ref: n
  }));
});
/*#__PURE__*/

export var DropdownMenuItem = /*#__PURE__*/c.forwardRef(function (e, n) {
  var r = e.__scopeDropdownMenu,
      t = _objectWithoutProperties(e, _excluded6),
      p = l(r);
  /*#__PURE__*/


  return c.createElement(o.Item, u({}, p, t, {
    ref: n
  }));
});
/*#__PURE__*/

export var DropdownMenuTriggerItem = /*#__PURE__*/c.forwardRef(function (e, n) {
  var r = e.__scopeDropdownMenu,
      t = _objectWithoutProperties(e, _excluded7),
      p = l(r);
  /*#__PURE__*/


  return c.createElement(o.SubTrigger, u({}, p, t, {
    ref: n
  }));
});
/*#__PURE__*/

export var DropdownMenuCheckboxItem = /*#__PURE__*/c.forwardRef(function (e, n) {
  var r = e.__scopeDropdownMenu,
      t = _objectWithoutProperties(e, _excluded8),
      p = l(r);
  /*#__PURE__*/


  return c.createElement(o.CheckboxItem, u({}, p, t, {
    ref: n
  }));
});
/*#__PURE__*/

export var DropdownMenuRadioGroup = /*#__PURE__*/c.forwardRef(function (e, n) {
  var r = e.__scopeDropdownMenu,
      t = _objectWithoutProperties(e, _excluded9),
      p = l(r);
  /*#__PURE__*/


  return c.createElement(o.RadioGroup, u({}, p, t, {
    ref: n
  }));
});
/*#__PURE__*/

export var DropdownMenuRadioItem = /*#__PURE__*/c.forwardRef(function (e, n) {
  var r = e.__scopeDropdownMenu,
      t = _objectWithoutProperties(e, _excluded10),
      p = l(r);
  /*#__PURE__*/


  return c.createElement(o.RadioItem, u({}, p, t, {
    ref: n
  }));
});
/*#__PURE__*/

export var DropdownMenuItemIndicator = /*#__PURE__*/c.forwardRef(function (e, n) {
  var r = e.__scopeDropdownMenu,
      t = _objectWithoutProperties(e, _excluded11),
      p = l(r);
  /*#__PURE__*/


  return c.createElement(o.ItemIndicator, u({}, p, t, {
    ref: n
  }));
});
/*#__PURE__*/

export var DropdownMenuSeparator = /*#__PURE__*/c.forwardRef(function (e, n) {
  var r = e.__scopeDropdownMenu,
      t = _objectWithoutProperties(e, _excluded12),
      p = l(r);
  /*#__PURE__*/


  return c.createElement(o.Separator, u({}, p, t, {
    ref: n
  }));
});
/*#__PURE__*/

export var DropdownMenuArrow = /*#__PURE__*/c.forwardRef(function (e, n) {
  var r = e.__scopeDropdownMenu,
      t = _objectWithoutProperties(e, _excluded13),
      p = l(r);
  /*#__PURE__*/


  return c.createElement(o.Arrow, u({}, p, t, {
    ref: n
  }));
});
/*#__PURE__*/

export var Root = DropdownMenu;
export var Trigger = DropdownMenuTrigger;
export var Content = DropdownMenuContent;
export var Group = DropdownMenuGroup;
export var Label = DropdownMenuLabel;
export var Item = DropdownMenuItem;
export var TriggerItem = DropdownMenuTriggerItem;
export var CheckboxItem = DropdownMenuCheckboxItem;
export var RadioGroup = DropdownMenuRadioGroup;
export var RadioItem = DropdownMenuRadioItem;
export var ItemIndicator = DropdownMenuItemIndicator;
export var Separator = DropdownMenuSeparator;
export var Arrow = DropdownMenuArrow;